import { render, staticRenderFns } from "./HandPaperIcon.vue?vue&type=template&id=6ca716a4&"
import script from "./HandPaperIcon.vue?vue&type=script&lang=js&"
export * from "./HandPaperIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports